import { cacheFirstConfig, CustomAxiosRequestConfig, http } from '@/core/helpers/axiosHelper';
import { AxiosRequestConfig } from 'axios';
import { LocationQuery } from 'vue-router';

export class WorkerStatuteService {
   async getWorkerStatutes(query?: LocationQuery) {
      return await http
         .get(`/worker-statutes`, { ...cacheFirstConfig, params: { ...query }, cancelable: false } as CustomAxiosRequestConfig)
         .then((response: any) => response.data.data);
   }
   async getFilteredWorkerStatutes(filters?: LocationQuery) {
      return await http
         .get(`/worker-statutes`, { params: { ...filters }, cancelable: false } as AxiosRequestConfig)
         .then((response: any) => response.data.data);
   }
}
